'use es6';

import { connect } from 'react-redux';
import FormSaveIndicator from 'ContentComponents/cmv2/form/FormSaveIndicator';
import * as FormsActions from 'ContentData/actions/Forms';
import * as formSelectors from 'ContentData/selectors/forms';
import { jsx as _jsx } from "react/jsx-runtime";
const FormSaveIndicatorContainer = (props = {}) => {
  const {
    form: {
      guid
    } = {},
    saveForm,
    reloadFormDraft
  } = props;
  return /*#__PURE__*/_jsx(FormSaveIndicator, Object.assign({}, props, {
    onRetry: () => saveForm(guid),
    onReload: () => reloadFormDraft(guid)
  }));
};
const mapStateToProps = (state, {
  form: {
    updatedAt
  } = {}
}) => ({
  isSaving: formSelectors.getIsSaving(state),
  isFailed: formSelectors.getIsSavingFailed(state),
  isPreConditionFailed: formSelectors.getIsSavingPreconditionFailed(state),
  updatedAt
});
const mapDispatchToProps = {
  saveForm: FormsActions.saveFormDraft,
  reloadFormDraft: FormsActions.reloadFormDraft
};
export default connect(mapStateToProps, mapDispatchToProps)(FormSaveIndicatorContainer);